import {
  MasterTransportByIdData,
  ParkinglistInput,
  ParkingLists,
  TransportationTypeItems,
} from "services/interface";
import styled from "@emotion/styled";
import { FormInstance, Row, Select } from "antd";
import { Dispatch, FC, SetStateAction } from "react";
import TransportationDescriptionForm from "./TransportationDescriptionForm";

const { Option } = Select;

interface MainCreateTransportationProps {
  form: FormInstance;
  dataType: TransportationTypeItems[] | undefined;
  data?: MasterTransportByIdData;
  parkingListInput: ParkinglistInput[];
  setParkingListInput: Dispatch<SetStateAction<ParkinglistInput[]>>;
}

const MainCreateTransportation: FC<MainCreateTransportationProps> = ({
  form,
  dataType,
  data,
  parkingListInput,
  setParkingListInput,
}) => {
  return (
    <FormWrapper>
      <FormItemWrapper>
        <Row gutter={[16, 16]} style={{ backgroundColor: "#EFEFEFEF" }}>
          <TransportationDescriptionForm
            data={data?.transport}
            form={form}
            dataType={dataType}
            is_active={true}
            parkingList={data?.parking_list}
            parkingListInput={parkingListInput}
            setParkingListInput={setParkingListInput}
          />
        </Row>
      </FormItemWrapper>
    </FormWrapper>
  );
};

export default MainCreateTransportation;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #efefefef;
`;

const FormItemWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px 0px 10px 0px;
  border-radius: 10px;
`;
